"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSiteWorkLineItems = exports.getSiteWorkLineItemsSum = void 0;
const core_1 = require("@natomas-org/core");
const getSiteWorkLineItemsSum = (publicProjectMetadata) => {
    var _a;
    if (!publicProjectMetadata) {
        return null;
    }
    const siteWorkLineItems = (0, exports.getSiteWorkLineItems)(publicProjectMetadata);
    if (!siteWorkLineItems) {
        return null;
    }
    return (_a = core_1.Price.sumPrices(...siteWorkLineItems.map((lineItem) => lineItem.price))) === null || _a === void 0 ? void 0 : _a.price;
};
exports.getSiteWorkLineItemsSum = getSiteWorkLineItemsSum;
const getSiteWorkLineItems = (publicProjectMetadata) => {
    var _a;
    return (publicProjectMetadata === null || publicProjectMetadata === void 0 ? void 0 : publicProjectMetadata.site_work_line_items)
        ? (_a = publicProjectMetadata === null || publicProjectMetadata === void 0 ? void 0 : publicProjectMetadata.site_work_line_items) === null || _a === void 0 ? void 0 : _a.filter((lineItem) => {
            return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineItemType) !== core_1.LineItemType.OTHER_LINE_ITEM_ID;
        })
        : null;
};
exports.getSiteWorkLineItems = getSiteWorkLineItems;
//# sourceMappingURL=PublicProjectMetadataAccessor.js.map